export default __webpack_public_path__ + "static/media/nikon_D5200.84874a9f.png";